import { ApplicationApi } from "../../../../../../../services/Api/Organization/types";

export interface AppState {
	app: ApplicationApi;
	config?: Record<string, any>;
	showPointsOfSale?: boolean;
}

export enum AppModalViewMode {
	"EMPTY" = "EMPTY",
	"DESCRIPTION" = "DESCRIPTION",
	"START" = "START",
	"FORM" = "FORM",
	"LOGS" = "LOGS",
}
